module.exports = __webpack_public_path__ + "img/logo_delcredere_full_x2.cf15896a.jpg";